import { UseQueryResult, useQuery } from 'react-query'
import { request } from '../request'

export const useGetCurrencies = (): UseQueryResult<
  Array<{ id: number; name: string; code: string; symbol: string }>,
  Error
> => {
  return useQuery(['currencies'], () =>
    request<Array<{ id: number; name: string; code: string; symbol: string }>>({
      url: '/utils/currencies',
      method: 'GET',
    }),
  )
}
